module.exports = __webpack_public_path__ + "img/neuquen.f852dda8.jpg";